import React, { Component } from 'react';
import './Recruitmentinfo.css';

export class RecruitmentInfo extends Component {
    render() {
        return (
            <div className='info-container'>
                <div className="info-title-container">
                    <h1 className="info-title">FALL 2026 RECRUITMENT</h1>
                </div>

                <div className="info-text-container">
                    <p className="info-text">
                        MAC Formula Electric is seeking motivated and passionate students who are looking for an opportunity
                        to learn and apply themselves to real-world engineering problems.
                        We are tackling the coming season through three core pillars of teamwide culture: Learning, Teamwork,
                        and Excellence. Our growth as a team comes from what we learn and how we learn it. Our successes and
                        failures come down to how we work together as a team to tackle the challenges ahead. Our progress as
                        a team depends on our commitment to the goal of besting our competition.

                        <br></br>
                        <br></br>
                        
                        Members of our team can expect to work with technologies, processes, and manufacturing
                        techniques that are seldom found in a classroom environment. By joining our team, students
                        can hone their technical and interpersonal skills and apply them throughout co-op placements,
                        full-time employment, and even research environments.

                        <br></br>
                        <br></br>
                        In the postings, the following definitions will be used:
                        <br></br>
                        <br></br>

                        <strong>Lower-year:</strong> students who are in their first or second year
                        <br></br>
                        <strong>Upper-year:</strong> students who are in their third year or above (also applies to graduate students)
                        
                        <span className="faq-note"> Please read the <a href="#faq">FAQ below</a> before emailing or messaging the team with recruitment-related questions. </span>
                    </p>
                </div>
                
            </div>
        )
    }
}

export default RecruitmentInfo
